import { render, staticRenderFns } from "./ManuscriptAutocompleteText.vue?vue&type=template&id=472f18ec&"
import script from "./ManuscriptAutocompleteText.vue?vue&type=script&lang=js&"
export * from "./ManuscriptAutocompleteText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports